import { Suspense, useEffect } from 'react';
import Modal from 'react-modal';
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import moment from 'moment/min/moment-with-locales';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider } from '@scramble/providers';
import { ModalProvider as DeprecatedModalProvider } from '@/components/ModalProvider';
import useSilentRefresh from '@/hooks/useSilentRefresh';
import { saveLastRoute, scrollTop } from '@/helpers/utils';
import { ModalProvider } from '@/providers/modal';
import { initYup } from '@/yup-config';
import { initSentry } from '@/sentry';
import config from '@/config';

import 'normalize.css';
import 'react-toastify/dist/ReactToastify.min.css';
import 'react-tippy/dist/tippy.css';

import '@scramble/design-system';
import '@/index.scss';
import '@/assets/styles/typography.scss';
import '@/assets/styles/themes/default.scss';
import '@/kit/Modal/index.css';

Modal.setAppElement('#root');

initSentry();
initYup();

export const AppProvider = () => {
  const location = useLocation();
  const { i18n } = useTranslation();
  const { isAuthReady } = useSilentRefresh();

  useEffect(() => {
    moment.locale(i18n.language);
  }, [i18n.language]);

  useEffect(() => {
    saveLastRoute(location);
  }, [location]);

  useEffect(() => {
    scrollTop();
  }, [location.pathname]);

  useEffect(() => {
    window.document.body.insertAdjacentHTML(
      'beforeend',
      `<div id="build" class="${config.release}">${config.release}</div>`,
    );
  }, []);

  if (!isAuthReady) {
    return null;
  }

  return (
    <ThemeProvider>
      <ModalProvider>
        <Suspense fallback={<div>loading....</div>}>
          <Outlet />
        </Suspense>
        <DeprecatedModalProvider />
        <ToastContainer />
      </ModalProvider>
    </ThemeProvider>
  );
};
